import React from 'react';

function MatchRowWeek({ item }) {
  const { week } = item;

  return (
    <div className="col-12 text-center py-2 bg-primary-blue">
      <p className="heading-h6 text-color-primary-black">VECKA {week}</p>
    </div>
  );
}

export default MatchRowWeek;
